/**
 * @generated SignedSource<<1dc7886cc155afa81e23b32a39b91c1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionInfo_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionActionBid_viewer" | "PdpSharedAuctionActionBinAndBid_viewer" | "PdpSharedAuctionPreview_viewer">;
  readonly " $fragmentType": "PdpSharedAuctionInfo_viewer";
};
export type PdpSharedAuctionInfo_viewer$key = {
  readonly " $data"?: PdpSharedAuctionInfo_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionInfo_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionInfo_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionPreview_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBid_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedAuctionActionBinAndBid_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f6d5f35c6cea3ab100b94426827f0ec4";

export default node;
